import { ContentfulButtonBlock } from '@jbhi-fi/apis/src/contentful/types';
import { ButtonBlockProps } from '../../ButtonBlock/ButtonBlock';
import { ButtonTransformer } from './ButtonTransformer';

export abstract class ButtonBlockTransformer {
  static toButtonBlockProps = (entry: ContentfulButtonBlock): ButtonBlockProps => {
    const transformedButtons = entry.fields?.buttons.map(ButtonTransformer.toLanyardButtonProps);
    return {
      alignment: entry.fields?.alignment ?? 'Left',
      buttons: transformedButtons ?? [],
      divider: entry.fields?.divider,
    };
  };
}
